import React from "react";
import get from "lodash/get";
import mapValues from "lodash/mapValues";
import debounce from "lodash/debounce";
import styles from "./Index.module.css";

import Sidebar from "../../components/Sidebar/Sidebar";
import NovicaPreview from "../../components/NovicaPreview";

class Novice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: "",
      allNovice: this.parseNovice(this.props.data),
      shownNovice: this.parseNovice(this.props.data).map(novica => novica.id)
    };
  }

  parseNovice = data => {
    return data.allContentfulNovica.edges.map(edge => {
      return {
        createdAt: new Date(edge.node.createdAt).toLocaleDateString(),
        id: edge.node.id,
        slika: get(edge.node, "[slika]", []),
        naslov: edge.node.naslov,
        opis: edge.node.opis.opis,
        datum: new Date(edge.node.datum).toLocaleDateString()
      };
    });
  };

  getNovice = () => {
    const { allNovice, shownNovice } = this.state;
    return shownNovice
      .map(id => {
        return allNovice.find(novica => novica.id === id);
      })
      .sort((a, b) => {
        return b.datum - a.datum;
      })
      .slice(0, 50);
  };

  updateSearchQuery = event => {
    this.setState(
      {
        searchQuery: event.target.value
      },
      () => {
        this.filterNovice(this.state.searchQuery);
      }
    );
  };

  filterNovice = debounce(searchQuery => {
    // If searchQuery is empty
    if (searchQuery === "") {
      // return all
      this.setState({
        shownNovice: this.parseNovice(this.props.data).map(novica => novica.id)
      });
    } else {
      const { allNovice } = this.state;
      const re = new RegExp(searchQuery.toLowerCase());
      const ids = allNovice
        .filter(novica => {
          let match = false;
          mapValues(novica, key => {
            if (key && re.test(key.toString().toLowerCase())) {
              match = true;
            }
          });
          return match;
        })
        .map(novica => novica.id);

      this.setState({
        shownNovice: ids
      });
    }
  }, 250);

  render() {
    const { searchQuery } = this.state;
    return (
      <div className={styles.novicePageContainer}>
        <div className={styles.noviceContainer}>
          {this.getNovice().map((novica, i) => (
            <NovicaPreview key={i} novica={novica} />
          ))}
        </div>
        <div className={styles.sidebarContainer}>
          <div className={styles.searchInputContainer}>
            <label className={styles.searchLabel}>Išči:</label>
            <input
              value={searchQuery}
              onChange={this.updateSearchQuery}
              type="text"
              name="searchQuery"
              className={styles.searchInput}
            />
          </div>
          <Sidebar />
        </div>
      </div>
    );
  }
}

export default Novice;

export const query = graphql`
  query allNoviceQuery {
    allContentfulNovica(sort: { fields: [datum], order: DESC }) {
      edges {
        node {
          datum
          id
          naslov
          createdAt
          opis {
            opis
          }
          slika {
            id
            file {
              url
            }
            description
          }
          tekst {
            tekst
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/novice/index.js